import React, { useState } from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import EditNotificationsIcon from "@mui/icons-material/EditNotifications";
import flowchangercolor from "../../../../src/Assets/Images/flowchangercolor.jpeg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from "@mui/icons-material/Delete";

const AiChat = () => {
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);

  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };

  return (
    <div className="px-4 py-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="flex items-center gap-[6px] font-medium text-[#262323] text-[16px]">
          <AutoAwesomeIcon className="cursor-pointer icons-crm" />
          Start New Chat
        </h1>
        <EditNotificationsIcon
          className="cursor-pointer"
          onClick={toggleOffCanvas} 
        />
      </div>

      <div className="flex flex-col justify-center items-center h-[450px]">
        <img className="w-[200px]" src={flowchangercolor} alt="Flowchanger" />
        <div className="flex gap-[14px] mt-[10px]">
          <button className="second-btn">Start New Chat</button>
          <button className="first-btn">Chat History</button>
        </div>
      </div>

      {/* Input Section */}
      <div className="relative top-[70px] mb-[40px]">
        <SettingsIcon className="top-[9px] left-[8px] absolute icons-crm" />
        <input
          className="border-[#d9d9d9] p-[7px] pl-[34px] border rounded-lg w-full placeholder:text-black focus-visible:outline-none"
          placeholder="Enter Message.... "
          type="text"
        />
        <KeyboardArrowRightIcon className="top-[8px] right-[3px] absolute icons-crm" />
      </div>

      {/* Off-Canvas */}
      <div
        className={`fixed top-[56px] right-0 h-full w-[300px] bg-white shadow-lg transform transition-transform duration-300 ${
          isOffCanvasOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <h2 className="font-medium text-[18px] text-gray-700">Chat History</h2>
          <button
            className="text-[black]"
            onClick={toggleOffCanvas}
          >
            <CloseIcon/>
          </button>
        </div>
        <div className="p-[10px]">
        <div className="flex justify-between items-center bg-white shadow-cs p-[8px] rounded-lg">
        <div>
          <h3 className="text-[#262323] text-[12px] md:text-[13px]">
            Flowchanger It Services support
          </h3>
          <span className="text-[#2b2a2d] text-[12px] md:text-[13px]">
            1 months ago
          </span>
        </div>
        <DeleteIcon className="text-[red] cursor-pointer" />
      </div>
      </div>
      </div>

      {/* Overlay */}
      {isOffCanvasOpen && (
        <div
          className="z-40 fixed inset-0 bg-black bg-opacity-30 w-[0]"
          onClick={toggleOffCanvas} // Close on overlay click
        ></div>
      )}
    </div>
  );
};

export default AiChat;
